export class SessionHall {
    $key: string;
    position: number;
    name: string = null;
    color: string = null;

}


// WEBPACK FOOTER //
// /app/src/app/core/models/session-hall.ts